import { apiGet } from '@/features/shared/utils/dataFetching'
import {
  type SuggestionsResponse,
  type SearchSuggestions,
} from '@/features/shared/services/Autocomplete/types'
import { normalizeSuggestions } from '@/features/shop/services/Search/utils'
import { type StoreLocationParams } from '@/features/shared/utils/dataFetching/storeParams'

export const fetchSearchSuggestions = async (
  query: SearchSuggestions,
  { store_id, metro_id, store_location_id }: StoreLocationParams,
) => {
  const response = await apiGet<SuggestionsResponse>({
    config: {
      url: '/autocomplete/v2/suggestions',
      params: {
        store_id,
        metro_id,
        store_location_id,
        ...query,
      },
    },
    fetcherName: 'fetchSearchSuggestions',
  })
  return normalizeSuggestions(response)
}

export const fetchMultiRetailerSearchSuggestions = async (
  query: SearchSuggestions,
  metro_id: number,
) => {
  const response = await apiGet<SuggestionsResponse>({
    config: {
      url: '/autocomplete/v2/multi-retailer/suggestions',
      params: {
        ...query,
        metro_id,
      },
    },
    fetcherName: 'fetchMultiRetailerSearchSuggestions',
  })
  return normalizeSuggestions(response)
}
